import apolloClient from './apolloClient'
import GetParticipatedFormCoversGQL from './graphql/GetParticipatedFormCovers.graphql'

import type { Entry, GetParticipatedFormCoversQuery, GetParticipatedFormCoversQueryVariables } from '@/typings/domain'

export type ParticipatedFormEntry = Pick<Entry, 'id' | 'token' | 'fieldValues' | 'serialNumber'>

export function getParticipatedFormCovers(variables: GetParticipatedFormCoversQueryVariables) {
  return apolloClient.query<GetParticipatedFormCoversQuery, GetParticipatedFormCoversQueryVariables>({
    query: GetParticipatedFormCoversGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}
